import ChipInput from '@component/ChipInput';
import Label from '@component/Label';
import TextArea from '@component/TextArea';
import { DescriptionModuleFormType } from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';
import { useGetGoals } from '@queries/Challenge/useGetGoals';
import { flatMapInfiniteData } from '@utils/query.utils';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import {
  DescriptionModule,
  DescriptionModuleConvertData2Form,
  DescriptionModuleConvertForm2Data,
} from '../../DescriptionModuleForm.type';
import { convertData2Form, convertForm2Data } from './GoalModule.serializer';
import { validate } from './GoalModule.validator';

type GoalModuleProps = {
  type: 'GOAL';
  mainHeader: string;
  subHeader: string;
  ids: number[];
  moduleIndex: number;
  onUpdate: (index: number, item: DescriptionModuleFormType) => void;
};
const GoalModule: DescriptionModule<GoalModuleProps> = (
  props: GoalModuleProps,
) => {
  const { type, mainHeader, subHeader, ids, moduleIndex, onUpdate } = props;

  const [keyword, setKeyword] = useState('');

  const { data, fetchNextPage, hasNextPage } = useGetGoals({
    keyword,
    isOfficial: false,
  });

  const goalOptions = flatMapInfiniteData(data, 'goals', 'id');

  const chipTitleGenerator = (id: number, title: string) => `${id}-${title}`;

  const handleMainHeaderChange = (value: string) => {
    onUpdate(moduleIndex, {
      type,
      subHeader,
      ids,
      ...{ mainHeader: value },
    });
  };

  const handleSubHeaderChange = (value: string) => {
    onUpdate(moduleIndex, {
      type,
      mainHeader,
      ids,
      ...{ subHeader: value },
    });
  };

  const handleGoalChange = (changedData: string[]) => {
    const options = goalOptions.filter(({ id }) =>
      changedData.find((t) => t.split('-')[0] === String(id)),
    );
    onUpdate(moduleIndex, {
      type,
      mainHeader,
      subHeader,
      ids: options.map(({ id }) => Number(id)),
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChangeKeyword = useCallback(_.debounce(setKeyword, 500), []);

  const handleReachEnd = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  return (
    <>
      <Label>메인헤더</Label>
      <TextArea value={mainHeader} onChange={handleMainHeaderChange} />
      <Label>서브헤더</Label>
      <TextArea value={subHeader} onChange={handleSubHeaderChange} />

      <Label>목표 목록</Label>

      <ChipInput
        placeholder="목표를 선택하세요."
        chipList={goalOptions
          .filter(({ id }) => ids.includes(id))
          .map(({ id, title }) => chipTitleGenerator(id, title))}
        searchable
        searchDataList={goalOptions.map(({ id, title }) =>
          chipTitleGenerator(id, title),
        )}
        searchDataAddable={false}
        onChange={handleGoalChange}
        onSearchChange={handleChangeKeyword}
        onReachEnd={handleReachEnd}
      />
    </>
  );
};

GoalModule.validate = validate;
GoalModule.convertForm2Data =
  convertForm2Data as DescriptionModuleConvertForm2Data;
GoalModule.convertData2Form =
  convertData2Form as DescriptionModuleConvertData2Form;
GoalModule.moduleName = '골 목록';
GoalModule.defaultData = {
  type: 'GOAL',
  mainHeader: '',
  subHeader: '',
  ids: [],
};
export default GoalModule;
